import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { BaseApiService } from '../base.api-service';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService extends BaseApiService {
  passwordForget(datas: FormData): Observable<any> {
    return this.http.post(
      environment.apiBasePaths.general + '/password/forget',
      datas
    );
  }

  validateToken(token: string): Observable<boolean> {
    return this.http.get<boolean>(
      // Le jeton est encodé : il vient d'un lien de courriel et son alphabet
      // n'est pas garanti sans caractère réservé. Un « + » non encodé se lit
      // comme une espace dans une chaîne de requête, et le jeton transmis ne
      // serait plus celui qui a été émis.
      environment.apiBasePaths.general +
        `/password/validate?token=${encodeURIComponent(token)}`
    );
  }

  resetPassword(datas: URLSearchParams): Observable<any> {
    return this.http.patch(
      environment.apiBasePaths.general + '/password/reset',
      datas,
      {
        // Sans cet en-tete, Angular n'annonce PAS le corps comme un formulaire :
        // un `URLSearchParams` natif n'est pas son `HttpParams`, et la requete
        // part avec un mauvais `Content-Type`. Or Symfony ne remplit
        // `$request->request` d'une requete PATCH que si le type est
        // `application/x-www-form-urlencoded` -- sinon le serveur recoit un
        // corps vide, la validation echoue et `/password/reset` repond 500.
        // Meme correctif deja en place dans `tasks.api-service.ts`.
        headers: new HttpHeaders({
          'content-type': 'application/x-www-form-urlencoded',
        }),
      }
    );
  }
}
